import { useSearch } from '@tanstack/react-router'
import { SellNewParcelCmp } from '../../components/features/parcels/creation/SellNewParcelCmp'
import { ParcelsManagement } from './ParcelsManagement'

export const ParcelsCnt = () => {
  const search: any = useSearch({ strict: false })
  const isSelling = window.location.pathname.endsWith('/vender')

  if (isSelling) {
    return <SellNewParcelCmp parcelId={search.parcelId} />
  }

  return <ParcelsManagement />
}
